// extracted by mini-css-extract-plugin
export default {"box":"_1E-Bj","singleHeader":"R0dvy","searchIcon":"GeXOU","button":"_3F1aU","arrow":"_2VRAe"};